import { PageInfoBar } from "@components/common/page-info-bar";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";
import { useMediaQueryList } from "@hooks/use-media-query";
import { CreateSnapshot } from "@pages/project-details/project-snapshots/create-snapshot";
import { SnapshotsBeingCreatedIndicator } from "@pages/project-details/project-snapshots/snapshots-being-created-indicator";
import { selectedProjectIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";

/** Renders a KPI bar for project snapshots tab */
export function ProjectSnapshotsKpi(): JSX.Element | null {
  const { isScreenSmOrSmaller } = useMediaQueryList();
  const selectedProjectId = useAppSelector(selectedProjectIdSelector);
  const { canCreateSnapshot } = useHasValidFeatureProjectLevel();

  if (!canCreateSnapshot || isScreenSmOrSmaller) {
    return null;
  }

  return (
    <PageInfoBar
      items={[
        {
          // Show the number of snapshots being created, or an empty item to keep
          // the height and spacing consistent with other KPI bars
          content: <SnapshotsBeingCreatedIndicator />,
        },
      ]}
      action={{
        content: selectedProjectId && (
          <CreateSnapshot projectId={selectedProjectId} />
        ),
        isHidden: !canCreateSnapshot,
      }}
    />
  );
}
